"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PeliasResult {
    constructor(location) {
        this.id = location.properties.id;
        this.city = location.properties.name;
        this.state_long_name = location.properties.region;
        this.state_short_name = location.properties.region_a;
        this.country_long_name = location.properties.country;
        this.country_short_name = location.properties.country_code || "";
        this.postal_code = "";
        this.setGeometry(location);
        this.setNames(location);
        this.setDropdownProperties();
    }
    setGeometry(location) {
        const [lng, lat] = location.geometry.coordinates;
        this.latitude = lat;
        this.longitude = lng;
    }
    setNames(location) {
        this.placeName = location.properties.label;
        if (this.city && this.state_long_name && this.country_long_name) {
            if (this.city !== this.state_long_name && this.state_long_name !== this.country_long_name) {
                this.placeName = [this.city, this.state_long_name, this.country_long_name].join(", ");
            }
        }
        this.displayName = this.placeName;
        this.name = this.placeName;
    }
    setDropdownProperties() {
        this.label = this.displayName;
        this.value = this.id;
    }
}
exports.default = PeliasResult;
